import { parseNumber } from '../../utils/number.utils';
import { SaleOfferControlDocument } from '../sale-offer-control-document';

export class SaleOfferControlDocumentBuilder {

  static fromJson(json): SaleOfferControlDocument {
    return (json) ? new SaleOfferControlDocument(
        json.hash,
        json.saleOfferHash,
        parseNumber(json.date),
        json.transportOperator,
        json.carrier,
        json.enrollment,
        json.trailer,
        json.observation,
        json.viewLogoInPdf,
        json.packingUnits
    ) : null;
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/core/models/builders/sale-offer-control-document-builder.ts